export default __webpack_public_path__ + "static/media/vpnManagement.9d16029a.png";